import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/dashboard/DashboardView.vue'),
      meta: { title: '监管大屏' },
    },
    {
      path: '/',
      component: () => import('@/layouts/MainLayout.vue'),
      redirect: '/bed/list',
      children: [
        {
          path: 'bed/list',
          name: 'bed-list',
          component: () => import('@/views/bed/BedListView.vue'),
          meta: { title: '床位监控' },
        },
        {
          path: 'bed/:id/sleep-report',
          name: 'bed-sleep-report',
          component: () => import('@/views/bed/SleepReportView.vue'),
          meta: { title: '睡眠报告' },
          props: true,
        },
        {
          path: 'area/list',
          name: 'area-list',
          component: () => import('@/views/area/AreaListView.vue'),
          meta: { title: '区域管理' },
        },
        {
          path: 'bcg/events',
          name: 'bcg-event-list',
          component: () => import('@/views/bcg/BcgEventListView.vue'),
          meta: { title: '异常事件' },
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFoundView.vue'),
      meta: { public: true },
    },
  ],
})

router.beforeEach((to) => {
  const auth = useAuthStore()
  if (!to.meta.public && !auth.token) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  return true
})

export default router
